export enum PrimasFilterType {
    Text,
    Number,
    DateTime,
    DropDown,
    Boolean,
    Date,
    DropDownList,
    DynamicContent,
    MailActions,
    JsonString,
    JsonNumber,
    StartWithText
}
